import { render } from "./OfferView.vue?vue&type=template&id=5e8a0d06&scoped=true"
import script from "./OfferView.vue?vue&type=script&lang=js"
export * from "./OfferView.vue?vue&type=script&lang=js"

import "@/assets/css/offer.css?vue&type=style&index=0&id=5e8a0d06&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8a0d06"]])

export default __exports__